import React from 'react';
import { ArrowLeftRightIcon } from 'lucide-react';
import { costRows } from '../data/content';
export function CostTable() {
  return <section aria-labelledby="costo-titulo" className="w-full bg-white py-14 sm:py-20" data-id="element-35" data-mp="27kx023989pm8">
      <div className="mx-auto max-w-4xl px-5" data-id="element-36" data-mp="1ttsaxv3hkfq5">
        <h2 id="costo-titulo" className="text-center font-display text-2xl font-extrabold uppercase tracking-wide text-navy sm:text-3xl" data-id="element-37" data-mp="1yqioobrtiz8e">
          ⚖️ ¿Cuánto cuesta no tenerlo?
        </h2>

        <p className="mt-6 flex items-center justify-center gap-2 text-xs font-semibold text-navy/60 sm:hidden" data-id="element-38" data-mp="2qh6nhh60rsiw">
          <ArrowLeftRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-39" data-mp="2chnk11o5l5cx" />
          Deslizá para ver la tabla completa
        </p>

        <div className="mt-3 overflow-x-auto rounded-2xl border border-navy/10 shadow-card" data-id="element-40" data-mp="2hjmko3sido66">
          <table className="w-full min-w-[520px] border-collapse text-left" data-id="element-41" data-mp="115cwb9o9nzfc">
            <caption className="sr-only" data-id="element-42" data-mp="163xy3dj62r5w">
              Costo real de seguir sin el MegaPack
            </caption>
            <thead data-id="element-43" data-mp="2nipdiq5p91fl">
              <tr className="bg-coral text-white" data-id="element-44" data-mp="2nk8s8cbpj4f9">
                <th scope="col" className="px-4 py-3 font-display text-sm font-bold" data-id="element-45" data-mp="2ji5grnp1fztz">
                  Sin MegaPack
                </th>
                <th scope="col" className="px-4 py-3 font-display text-sm font-bold" data-id="element-46" data-mp="2xe8vs9rcc1lv">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-47" data-mp="36fqm0kygpjoa">
              {costRows.map((row, index) => <tr key={row.without} className={index % 2 === 1 ? 'bg-cream' : 'bg-white'} data-id="element-48" data-mp="32ghpx9fy99pk" data-mpi={index}>
                  <th scope="row" className="border-t border-navy/10 px-4 py-3 text-sm font-bold text-navy" data-id="element-49" data-mp="3g7cs62vy0sk6">
                    {row.without}
                  </th>
                  <td className="border-t border-navy/10 px-4 py-3 text-sm text-navy/75" data-id="element-50" data-mp="3q62cs3f84r44">
                    {row.cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="mt-10 text-center font-display text-2xl font-extrabold text-navy sm:text-3xl" data-id="element-51" data-mp="3s7b6hif7rkc5">
          El próximo domingo puede ser diferente.
        </p>
        <p className="mt-2 text-center text-base font-semibold text-celeste-dark" data-id="element-52" data-mp="61e6gkde0t9c">
          “El próximo fin de semana puede ser diferente.” 🇦🇷
        </p>
      </div>
    </section>;
}